import { bossEndpoints } from "store/apis/bossAPI/boss.api"

export const {
  useGetBossStatsQuery,
  useGetBossUpgradeCostQuery,
  useUpgradeBossStatMutation,
  useGetBossUpgradesQuery,
  useGetBossEnergyQuery,
  useGetBossEnergyUpgradeCostQuery,
  useUpgradeBossEnergyMutation,
  useRecordFailedEnergyUpgradeMutation,
  useGetBossHealthQuery,
  useAttackBossMutation,
  useCollectDropMutation,
  useGetBossPendingDropsQuery,
  useGetBossActivityLogsQuery,
  useGetPvpLogsQuery,
  useGetBossAbilitiesQuery,
  useGetDarkRespecInfoQuery,
  useDarkRespecMutation,
  useActivateBerserkerMutation,
  usePvpAttackMutation,
  useFindArenaOpponentMutation,
  useGetArenaCurrentMatchQuery,
  useArenaAttackMutation
} = bossEndpoints
